<template>
    <Transition>
        <div
            id="overlay"
            v-if="$store.state.isBlackLayout"
        ></div>
    </Transition>
</template>

<script>
export default {
    name: "BlackLayoutForPopUp"
}
</script>

<style scoped>

#overlay {
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.6); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
    opacity: 0;
}

</style>
